import React from 'react';
import AuthService from './authService.js';
import TpEvaluatorLinkItem from '../Domain/TpEvaluatorLinkItem.js';
import SearchParams from '../Elements/SearchParams';
import TpEvaluatorLinkSearchParams from '../Contents/ThirdParty/TpEvaluator/TpEvaluatorLinkSearchParams';

export default class TpEvaluatorLinkService extends React.Component {
  static GetAllItemBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, TpEvaluatorLinkSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    const url = `/api/TpEvaluatorLink/GetItems/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunction(url);
  }

  static ConvertDBItems(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new TpEvaluatorLinkItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }
}
